// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const AssetCaseUnlinkApiAssetsAssetIdCasesCaseIdDeleteParams = zod.object({
  "revision": zod.int().min(1)
})

export type AssetCaseUnlinkApiAssetsAssetIdCasesCaseIdDeleteParams = zod.input<typeof AssetCaseUnlinkApiAssetsAssetIdCasesCaseIdDeleteParams>;
export type AssetCaseUnlinkApiAssetsAssetIdCasesCaseIdDeleteParamsOutput = zod.output<typeof AssetCaseUnlinkApiAssetsAssetIdCasesCaseIdDeleteParams>;
